module.exports = __webpack_public_path__ + "img/notificationBad.d14cd80e.svg";